import { render } from "./Pricing2.vue?vue&type=template&id=5c97ccde"
import script from "./Pricing2.vue?vue&type=script&lang=js"
export * from "./Pricing2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__